import constants from 'Constants';
import * as comUtils from 'utils/Common';


export function isProduction() {
  if (process.env.NODE_ENV === 'production') {
    return true;
  } else {
    return false;
  }
}

export function getModalDefaultStyles() {
  return {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(41, 72, 96, 0.85)',
        zIndex: 5,
    },

    // `transform: translate(-50%, -50%)` will cause blurry lines in chrome
    // see https://stackoverflow.com/a/28565387/1446284
    content: {
        top: '20%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translateX(-50%)',
        textAlign: 'center',
        borderRadius: '4px',
        backgroundColor: 'white',
        width: 'auto',
        padding: '0',
        border: 'inherit',
        overflow: 'visible'
    }
  };
}


export function getPopperModifiers() {
  // Need set modifier to prevent overflow
  // See https://github.com/palantir/blueprint/issues/2352
  return  {
    preventOverflow: {
      boundariesElement: "window"
    },
    flip: {
      enabled: false
    }
  };
}


export function getBpSelectPopoverModifiers() {
  return {
    arrow: {
      enabled: true
    },
    flip: {
      enabled: true
    },
    preventOverflow: {
     enabled: true
    },
  }
}


export function getStripePublicKey() {
  if (isProduction()) {
    return constants.STRIPE_PUBLIC_KEY_LIVE;
  } else {
    return constants.STRIPE_PUBLIC_KEY_TEST;
  }
}

export function getLoaderScriptUrl() {
  if (isProduction()) {
    return constants.LOADER_SCRIPT_URL_PRODUCTION;
  } else {
    return constants.LOADER_SCRIPT_URL_DEV;
  }
}

export function getLoaderSnippet() {
  return `
    <script>
      (function() {
        window.OnVoard = window.OnVoard || function() {
          (window.OnVoard.q = window.OnVoard.q || []).push(arguments);
        };
        var script = document.createElement("script");
        var parent = document.getElementsByTagName("script")[0].parentNode;
        script.async = 1;
        script.src = "${getLoaderScriptUrl()}";
        parent.appendChild(script);
      })();
    </script>
  `;
}

export function getProductDetails(productValue) {
  return constants.PRODUCT_DETAILS.filter((product) => product.value === productValue)[0];
}

export function getSourceDetails(sourceId) {
  return constants.SOURCE_DETAILS[sourceId];
}

export function isProductEligibleForSource(sourceId, product) {
  const sourceDetails = getSourceDetails(sourceId);
  if (!sourceDetails) return false;
  return sourceDetails.eligible_products.includes(product);
}

export function generateBucketUrl(filepath, options) {
  if (!options) {
    options = {};
    options['useCdn'] = true;
  }

  if (!isProduction()) {
    return `https://r2-dev.onvoard.com/${filepath}`;
  }

  if (options.useCdn) {
    return `https://cdn.onvoard.com/${filepath}`;
  }

  return `https://r2.onvoard.com/${filepath}`;
}

export function generateWidgetsPreviewUrl(filepath) {
  if (isProduction()) return `https://scripts.onvoard.com/apps-preview/${filepath}`;

  const cachebusterId = comUtils.getRandomInt(0, 10000);
  return `https://r2-scripts-dev.onvoard.com/apps-preview/${filepath}?cachebuster=${cachebusterId}`;
}

export function getWidgetsLoaderUrl() {
  if (isProduction()) return `https://scripts.onvoard.com/apps-preview/loader.js`;

  const cachebusterId = comUtils.getRandomInt(0, 10000);
  return `https://r2-scripts-dev.onvoard.com/apps-preview/loader.js?cachebuster=${cachebusterId}`;
}

export function getPlanTierIndex(tier) {
  if (!tier) return 0;
  return constants.PLAN_TIERS.indexOf(tier) || 0;
}

export function getPlanTierProductsLimit(tier) {
  if (!tier) return;
  return constants.PLAN_TIERS_PRODUCTS_LIMIT[tier];
}

export function getPackageName(packageValue) {
  let option = constants.SUBSCRIPTION_PACKAGE_OPTIONS.filter((option) => option.value === packageValue)[0];
  if (!option) return;
  return option.label;
}

export function generateShopifyAppBlockDeepLink(params) {
  let myshopify_domain = params.myshopify_domain;
  let template = params.template;
  let uuid = params.uuid;
  let handle = params.handle;

  if (!myshopify_domain || !template || !uuid) return;
  return `https://${myshopify_domain}/admin/themes/current/editor?context=apps&template=${template}&activateAppId=${uuid}/${handle}`;
}


export function getSnippetBeautifyOptions() {
  return {
      "indent_size": "2",
      "indent_char": " ",
      "max_preserve_newlines": "5",
      "preserve_newlines": true,
      "keep_array_indentation": false,
      "break_chained_methods": false,
      "indent_scripts": "normal",
      "brace_style": "collapse",
      "space_before_conditional": true,
      "unescape_strings": false,
      "jslint_happy": false,
      "end_with_newline": false,
      "wrap_line_length": "50",
      "indent_inner_html": false,
      "comma_first": false,
      "e4x": false,
      "indent_empty_lines": false
    }
}
